















































































import "./profile-editor.less";
import Vue from "vue";
import ImageInput from "../../../common/imageinput.vue";
import UserAvatar from "../../../common/user-avatar.vue";
import PasswordInput from "../../../common/passwordInput.vue";
import { VueTelInput } from "vue-tel-input";

export default Vue.extend({
  name: "profile-editor",
  components: {
    ImageInput,
    UserAvatar,
    PasswordInput,
    VueTelInput,
  },
  props: {
    profile: Object,
    showEditor: Boolean,
  },
  data() {
    return {
      rules: {
        name: [
          {
            required: true,
            message: "Please fill in your full name",
            trigger: "blur",
          },
        ],
        phoneNumber: [
          {
            required: true,
            message: "Please fill in phone number",
            trigger: "blur",
          },
        ],
        emailAddress: [
          {
            required: true,
            message: "Please enter email address",
            trigger: "blur",
          },
          { type: "email", message: "Incorrect email format", trigger: "blur" },
        ],
        password: [
          {
            required: true,
            message: "Please fill in the old password",
            trigger: "blur",
          },
        ],
        newPassword: [
          {
            validator: (rule, value, callback) => {
              if (value === "") {
                callback(new Error("Please enter your new password"));
              } else {
                if ((this as any).checkPassword(value)) {
                  if ((this as any).profile.newPasswordConfirm !== "") {
                    (this.$refs.EdittingForm as any).validateField("newPasswordConfirm");
                  }
                } else {
                  callback(new Error("Not a valid password."));
                }

                callback();
              }
            },
            trigger: "blur",
          },
        ],
        newPasswordConfirm: [
          {
            validator: (rule, value, callback) => {
              if (value !== this.profile.newPassword) {
                callback(new Error("Passwords do not match!"));
              } else {
                callback();
              }
            },
            trigger: "blur",
          },
        ],
      },
      bindPhoneProps: {
        mode: "international",
        defaultCountry: "US",
        disabledFetchingCountry: false,
        disabled: false,
        disabledFormatting: false,
        placeholder: "Mobile Phone (for two-factor authentication)",
        required: true,
        enabledCountryCode: false,
        enabledFlags: true,
        preferredCountries: ["US"],
        onlyCountries: [],
        ignoredCountries: [],
        autocomplete: "off",
        name: "telephone",
        maxLen: 25,
        wrapperClasses: "",
        inputClasses: "",
        dropdownOptions: {
          disabledDialCode: false,
        },
        inputOptions: {
          showDialCode: false,
        },
      },
      has_eight_characters: false,
      has_number: false,
      has_lowercase: false,
      has_uppercase: false,
      has_special: false,
      resetCompleted: false,
      changePassword: false,
      changeAvatarImage: false,
      avatar: null,
    };
  },
  computed: {
    showModal(): any {
      return this.showEditor;
    },
  },
  watch: {
    showModal(newVal) {
      if (newVal === true) {
        this.changePassword = false;
      }
    },
  },
  methods: {
    checkPassword(input) {
      let password = input || this.profile.newPassword;
      this.has_eight_characters = password && password.length > 7;
      this.has_number = /\d/.test(password);
      this.has_lowercase = /[a-z]/.test(password);
      this.has_uppercase = /[A-Z]/.test(password);
      this.has_special = /[!@#\$%\^\&*\)\(+=._-]/.test(password);

      return this.has_eight_characters && this.has_number && this.has_lowercase && this.has_uppercase && this.has_special;
    },
    handleAvatarInput(avatar) {
      this.profile.avatarImageUrl = avatar.imageURL;
      this.changeAvatarImage = true;
    },
    validatePhoneNumber() {
      let field = this.$refs.PhoneNumberField as any;
      field.validate("");
    },
    handleSave() {
      event.preventDefault();
      let target = (event.target as any).closest("button") as HTMLButtonElement;
      target.disabled = true;

      let context = this;
      (this.$refs.EdittingForm as any).validate((valid: boolean) => {
        if (valid) {
          let requestData = {
            name: this.profile.name,
            emailAddress: this.profile.emailAddress,
            phoneNumber: this.profile.phoneNumber,
            changePassword: this.changePassword,
            currentPassword: "",
            newPassword: this.profile.password,
            changeAvatarImage: this.changeAvatarImage,
            avatarImage: "",
            billingAccountName: "ignore",
          };

          if (this.changePassword) {
            requestData.currentPassword = this.profile.password;
            requestData.newPassword = this.profile.newPassword;
          }

          if (this.changeAvatarImage) {
            requestData.avatarImage = this.profile.avatarImageUrl;
          }

          context.$store
            .dispatch("account/updateProfile", requestData)
            .then((response) => {
              if (response.success === true) {
                context.$store.dispatch("session/init");
                context.$emit("cancel");
              } else {
                this.$Modal.error({
                  title: "Oops!",
                  render: (h) => {
                    return h("p", [h("span", {}, response.errorMessage)]);
                  },
                });
              }
            })
            .catch((error) => {
              if (error.response.data.error) {
                if (error.response.data.error.code === 10003) {
                  this.$Modal.error({
                    title: "Oops!",
                    render: (h) => {
                      return h("p", [h("span", {}, error.response.data.error.details + " "), h("a", { on: { click: this.handleGoToRecover } }, "Click here to recover your password.")]);
                    },
                  });
                }
              } else {
                this.$Modal.error({
                  title: "Oops!",
                  render: (h) => {
                    return h("p", "Unexpected Error! Please contact your administrator.");
                  },
                });
              }
            })
            .finally(() => {
              target.disabled = false;
            });
        } else {
          target.disabled = false;
        }
      });
    },
    handleGoToRecover() {
      this.$Modal.remove();
      this.$router.push({
        name: "forgot",
      });
    },
  },
});
